import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Debug: Descomente para verificar se o DSN do Sentry está configurado
// console.log('🔍 Sentry DSN:', import.meta.env.VITE_SENTRY_DSN ? '✅ Configurado' : '❌ Não encontrado');

// Inicializar Sentry antes de renderizar o app
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  
  // Envia dados padrão (IP, user-agent) para melhor contexto nos erros
  // Os dados sensíveis são removidos pelo hook beforeSend abaixo
  sendDefaultPii: true,
  
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  
  beforeSend(event) {
    if (event.request) {
      delete event.request.cookies;
      
      if (event.request.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['Cookie'];
      }
    }
    
    if (event.user?.email) {
      event.user.email = event.user.email.replace(
        /(.{2})(.*)(@.*)/,
        '$1***$3'
      );
    }
    
    return event;
  },
  
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
  ],
});

// Debug: Descomente para confirmar inicialização
// console.log('✅ Sentry inicializado com sucesso');

createRoot(document.getElementById("root")!).render(<App />);
